import { BaseList, BaseDetail } from "App/Component/Bases";
import fields from "./fields";
import descriptor from "./descriptor";
import options from "./options";

const title = "Mapping Modes";
const urlData = "mappingModes";
const bulkName = "name";
const appName = "merchant";
const modelName = "mappingmode";

class List extends BaseList {
  constructor(props) {
    super(props)

    this.title = title;
    this.urlData = urlData;
    this.bulkName = bulkName;
    this.propsList = {
      descriptor,
      exportImport: options.exportImportOptions,
    }
  }
  
  getAppName = () => appName;

  getModelName = () => modelName;
}

class Detail extends BaseDetail {
  constructor(props) {
    super(props)

    this.title = title
    this.urlData = urlData
    this.bulkName = bulkName
    this.fields = fields
    this.propsDetail = {
      urlKeyHistory: 'api:admin:merchants:mappingmode:detail-revision',
      keyLabel: 'name'
    }
  }
  
  getAppName = () => appName;

  getModelName = () => modelName;
}

export default { List, Detail };